export const globalConstants = {
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
  SET_GLOBAL_LOADING_VISIBLE: "SET_GLOBAL_LOADING_VISIBLE"
};
